import { getTableFormattedDate } from "../../helpers/date-time-helper";
import { ColumnDef, createColumnHelper} from "@tanstack/table-core";
import { TWorkSession } from "../../common/types";
import { Link } from "react-router-dom";

type TableWorkSessions = Pick<TWorkSession, 'id' | 'sessionDate' | 'totalHours' | 'machineNumber' | 'operatorFullName' | 'startTime' | 'job'>
type TValue = string | number;

const columnHelper = createColumnHelper<TableWorkSessions>();

export const Columns: ColumnDef<TableWorkSessions, TValue>[] = [
    columnHelper.accessor<'sessionDate', string>('sessionDate', {
        id: "sessionDate",
        header: "Session Date",
        enableColumnFilter: false,
        cell: (cellProps) => getTableFormattedDate(cellProps.getValue()),
    }),
    columnHelper.accessor<'totalHours', number>('totalHours', {
        id: "totalHours",
        header: 'Total Hours Worked',
        enableColumnFilter: false,
        cell: (cellProps) => Number(cellProps.getValue().toFixed(2))
    }),
    columnHelper.accessor<'machineNumber', string>('machineNumber', {
        id: "machineNumber",
        header: 'Machine',
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'operatorFullName', string>('operatorFullName', {
        id: "operatorFullName",
        header: 'Operator',
        enableColumnFilter: false,
    }),
    columnHelper.accessor<'job.name', string>('job.name', {
        id: "jobName",
        header: 'Job Name',
        enableColumnFilter: false,
    }),
    columnHelper.display({
        id: "controls",
        header: 'Details',
        cell: (props) => (
            <Link to={`${props.row.original.id}`}>
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </Link>
        ),
    }),
];
